import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";

/**
 * Accessible single-open accordion.
 * @param {Array<{q:string,a:string}>} items
 */
export default function FAQ({ items }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="max-w-3xl mx-auto space-y-3">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div
            key={i}
            className={`rounded-2xl border transition-colors overflow-hidden ${
              isOpen
                ? "bg-white border-gold-300 shadow-premium"
                : "bg-white border-gold-100 hover:border-gold-200"
            }`}
          >
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
            >
              <span className="font-heading text-maroon-800 text-base sm:text-lg">{item.q}</span>
              <span
                className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                  isOpen ? "bg-saffron-500 text-white rotate-45" : "bg-saffron-50 text-saffron-600"
                }`}
              >
                <FiPlus />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <p className="px-5 pb-5 text-gray-600 leading-relaxed text-sm">{item.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
